<template>
  <div class="wrap" :style="{ 'filter': 'brightness(' + this.brightness + '%)'}">
    <v-btn :style="{width: (100 - this.widthSize) + '%'}" class="nav-btn left" @click.stop="prev" v-shortkey="['arrowleft']" @shortkey="prev" v-tooltip:top="{ html: 'Navigate previous page/chapter' }" :ripple="false">
      <v-icon :style="{'right': (this.widthSize * 7) + 'px'}">chevron_left</v-icon>
    </v-btn>
    <v-btn :style="{width: (100 - this.widthSize) * 2 + '%'}" class="nav-btn right" @click.stop="next" v-shortkey="['arrowright']" @shortkey="next" v-tooltip:top="{ html: 'Navigate next page/chapter' }" :ripple="false">
      <v-icon :style="{'right': (this.widthSize * 7) + 'px'}">chevron_right</v-icon>
    </v-btn>
    <div class="book-content" :style="{'width': this.widthSize + '%', 'background-color': this.currentColor}">
      <div class="book-page" :class="this.fontFamily" :style="{ 'font-size': this.fontSize + 'px', 'columns': this.cols }" :key="div" v-on:mouseenter="over" v-on:mouseleave="out" >
        <transition :name="routeTransition">
            <router-view class="view"></router-view>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import eventHub from "../event-hub.js";
import Settings from "../components/Settings";

var SLIDE_TIME = document.documentElement.clientWidth > 480 ? 500 : 300;

export default {
  name: "reader",
  props: {
    value1: {
      type: Number,
      default: 22
    },
    selected: {
      type: String
    },
    ex8: {
      type: String,
      default: "Auto"
    },
    value2: {
      type: Number
    },
    value3: {
      type: Number,
      default: 100
    }
  },
  data() {
    return {
      home: false,
      div: 0,
      prevX: null,
      xDownEnd: null,
      fontSize: this.value1,
      fontFamily: this.selected,
      columns: this.ex8,
      widthSize: this.value2,
      brightness: this.value3,
      currentColor: "#f3f3f3",
      cols: "2 220px",
      position: { scrollTop: 0, scrollLeft: 0 },
      offset: null,
      isOver: false,
      routeNames: [
        "home",
 		    "1-cover",
           		    "2-copyright",
           		    "3-TOC",
           		    "4-introduction-open",
           		    "5-introduction",
                                                                                                                        ,
        "last"
      ],
      routeTransition: "slide-left",
      rest: true,
      selectedView: "Book1"
    };
  },
  created: function() {
    this.$router.options.routes.forEach(route => {
      this.routeNames.push(route.name);
    });
    eventHub.$on("fontSizeChanged", newValue => {
      this.fontSize = newValue;
    });
    eventHub.$on("fontFamilyChanged", newValue => {
      this.fontFamily = newValue;
    });
    eventHub.$on("columnsCountChanged", newValue => {
      this.columns = newValue;
      if (this.columns === "Single") {
        this.cols = "1 auto";
      } else if (this.columns === "Auto") {
        this.cols = "2 220px";
      }
    });
    eventHub.$on("widthChanged", newValue => {
      this.widthSize = newValue;
    });
    eventHub.$on("brightnessChanged", newValue => {
      this.brightness = newValue;
    });

    (function() {
      var throttle = function(type, name, obj) {
        obj = obj || window;
        var running = false;
        var func = function() {
          if (running) {
            return;
          }
          running = true;
          requestAnimationFrame(function() {
            obj.dispatchEvent(new CustomEvent(name));
            running = false;
          });
        };
        obj.addEventListener(type, func);
      };
      throttle("resize", "optimizedResize");
    })();

    var optimizedResize = (function() {
      var callbacks = [],
        running = false;
      function resize() {
        if (!running) {
          running = true;
          if (window.requestAnimationFrame) {
            window.requestAnimationFrame(runCallbacks);
          } else {
            setTimeout(runCallbacks, 66);
          }
        }
      }
      function runCallbacks() {
        callbacks.forEach(function(callback) {
          callback();
        });
        running = false;
      }
      function addCallback(callback) {
        if (callback) {
          callbacks.push(callback);
        }
      }
      return {
        add: function(callback) {
          if (!callbacks.length) {
            window.addEventListener("resize", resize);
          }
          addCallback(callback);
        }
      };
    })();
    optimizedResize.add();

    (function() {
      window.addEventListener("resize", resizeThrottler, false);
      var resizeTimeout;
      function resizeThrottler() {
        if (!resizeTimeout) {
          resizeTimeout = setTimeout(function() {
            resizeTimeout = null;
            actualResizeHandler();
          }, 66);
        }
      }
      function actualResizeHandler() {
        var page = document.getElementsByClassName("book-page")[0],
          gap = parseInt(
            window.getComputedStyle(page).getPropertyValue("column-gap"),
            10
          ),
          offset = page.offsetWidth + gap;
        page.scrollLeft = offset;
      }
    })();

    document.addEventListener("mousewheel", this.onScroll, false);
    document.addEventListener("touchstart", this.handleTouchStart, false);
    document.addEventListener("touchmove", this.handleTouchMove, false);
    document.addEventListener("touchend", this.handleTouchEnd, false);
  },
  destroyed: function() {
    document.removeEventListener("mousewheel", this.onScroll, false);
    document.removeEventListener("touchstart", this.handleTouchStart, false);
    document.removeEventListener("touchmove", this.handleTouchMove, false);
    document.removeEventListener("touchend", this.handleTouchEnd, false);
  },
  mounted() {
    var bgColor = document.getElementsByClassName("book-content")[0].style
        .backgroundColor,
      hexDigits = new Array(
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "a",
        "b",
        "c",
        "d",
        "e",
        "f"
      );
    function rgb2hex(rgb) {
      rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }
    function hex(x) {
      return isNaN(x) ? "00" : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16];
    }
    this.currentColor = rgb2hex(bgColor);
  },
  watch: {
    $route(to, from, next) {
      var toDepth = this.routeNames.indexOf(to.name);
      var fromDepth = this.routeNames.indexOf(from.name);
      this.routeTransition = toDepth < fromDepth ? "slide-right" : "slide-left";
    }
  },
  methods: {
    slidePage: function(page, offset) {
      var start = Date.now();
      var startX = page.scrollLeft;
      function slide() {
        var timestamp = Date.now();
        var progress = timestamp - start;
        var x = Math.min(1, progress / SLIDE_TIME) * offset;
        page.scrollLeft =
          offset > 0
            ? Math.min(startX + x, startX + offset)
            : Math.max(startX + x, startX + offset);
        if (progress < SLIDE_TIME) requestAnimationFrame(slide);
      }
      requestAnimationFrame(slide);
    },
    next: function(e) {
      var page = this.$el.querySelector(".book-page"),
        gap = parseInt(
          window.getComputedStyle(page).getPropertyValue("column-gap"),
          10
        ),
        offset = page.offsetWidth + gap,
        index = this.routeNames.indexOf(this.$route.name);
      if (page.scrollWidth - (page.scrollLeft + page.offsetWidth) !== 0) {
        var pageNumber = Math.floor(page.scrollLeft / (page.offsetWidth + gap));
        var nextPage = Math.floor((pageNumber + 1) * (page.offsetWidth + gap));
        var currentPage = Math.floor(pageNumber * (page.offsetWidth + gap));
        if (page.scrollLeft > currentPage) {
          offset = nextPage - page.scrollLeft;
        }
        this.slidePage(page, offset);
      } else {
        this.$router.push({ name: this.routeNames[index + 1] });
      }
    },
    prev: function(e) {
      var page = this.$el.querySelector(".book-page"),
        gap = parseInt(
          window.getComputedStyle(page).getPropertyValue("column-gap"),
          10
        ),
        offset = page.offsetWidth + gap,
        index = this.routeNames.indexOf(this.$route.name),
        pageNumber = Math.floor(page.scrollLeft / (page.offsetWidth + gap)),
        currentPage = Math.floor(pageNumber * (page.offsetWidth + gap));
      if (page.scrollLeft !== 0 && currentPage !== 0) {
        if (page.scrollLeft > currentPage) {
          var prevPage = Math.floor(pageNumber * (page.offsetWidth + gap));
          offset = page.scrollLeft - prevPage;
        }
        this.slidePage(page, -offset);
      } else {
        this.$router.push({ name: this.routeNames[index - 1] });
      }
    },
    over: function() {
      this.isOver = true;
    },
    out: function() {
      this.isOver = false;
    },
    onScroll: function(e, position) {
      this.position = position;
      if (this.isOver === true) {
        var page = this.$el.querySelector(".book-page"),
          gap = parseInt(
            window.getComputedStyle(page).getPropertyValue("column-gap"),
            10
          ),
          deltaX = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail)),
          end = page.scrollWidth - (page.scrollLeft + page.offsetWidth),
          offset = page.offsetWidth + gap;

        if (deltaX === 1) {
          var page = this.$el.querySelector(".book-page"),
            gap = parseInt(
              window.getComputedStyle(page).getPropertyValue("column-gap"),
              10
            ),
            offset = page.offsetWidth + gap,
            pageNumber = Math.floor(page.scrollLeft / (page.offsetWidth + gap)),
            currentPage = Math.floor(pageNumber * (page.offsetWidth + gap));
          if (page.scrollLeft !== 0 && currentPage !== 0) {
            if (page.scrollLeft > currentPage) {
              var prevPage = Math.floor(pageNumber * (page.offsetWidth + gap));
              offset = page.scrollLeft - prevPage;
            }
            this.slidePage(page, -offset);
            page.scrollLeft = 0;
          }
        } else if (deltaX === -1) {
          var page = this.$el.querySelector(".book-page"),
            gap = parseInt(
              window.getComputedStyle(page).getPropertyValue("column-gap"),
              10
            ),
            offset = page.offsetWidth + gap;
          if (page.scrollWidth - (page.scrollLeft + page.offsetWidth) !== 0) {
            var pageNumber = Math.floor(
              page.scrollLeft / (page.offsetWidth + gap)
            );
            var nextPage = Math.floor(
              (pageNumber + 1) * (page.offsetWidth + gap)
            );
            var currentPage = Math.floor(pageNumber * (page.offsetWidth + gap));
            if (page.scrollLeft > currentPage) {
              offset = nextPage - page.scrollLeft;
            }
            this.slidePage(page, offset);
            page.scrollLeft = 0;
          }
        }
      } else {
        return;
      }
    },
    fadeIn: function() {
      var page = this.$el.querySelector(".book-page");
      page.style.opacity = 0;
      var last = +new Date();
      var tick = function() {
        page.style.opacity = +page.style.opacity + (new Date() - last) / 400;
        last = +new Date();
        if (+page.style.opacity < 1) {
          (window.requestAnimationFrame && requestAnimationFrame(tick)) ||
            setTimeout(tick, 16);
        }
      };
      tick();
    },

    resetScroll: function() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    },

    handleTouchStart: function(evt) {
      this.touchStart = evt.pageX || evt.touches[0].pageX;
      this.prevX = evt.pageX || evt.touches[0].pageX;
    },
    handleTouchMove: function(evt) {
      if (!this.prevX) {
        return;
      }
      var xDownEnd = evt.pageX || evt.changedTouches[0].pageX;
      var page = this.$el.querySelector(".book-page"),
        gap = parseInt(
          window.getComputedStyle(page).getPropertyValue("column-gap"),
          10
        ),
        offset = page.offsetWidth + gap;

      var xDiff = this.prevX - xDownEnd,
        index = this.routeNames.indexOf(this.$route.name),
        page = this.$el.querySelector(".book-page"),
        gap = parseInt(
          window.getComputedStyle(page).getPropertyValue("column-gap"),
          10
        ),
        offset = page.offsetWidth + gap;

      if (xDiff > 0) {
        if (page.scrollWidth - (page.scrollLeft + page.offsetWidth) !== 0) {
          page.scrollLeft += xDiff;
        } else {
          this.$router.push({ name: this.routeNames[index + 1] });
          page.scrollLeft = 0;
        }
      } else {
        if (page.scrollLeft !== 0) {
          page.scrollLeft += xDiff;
        } else {
          this.$router.push({ name: this.routeNames[index - 1] });
          page.scrollLeft = 0;
        }
      }
      this.prevX = xDownEnd;
    },
    handleTouchEnd: function(evt) {
      if (!this.touchStart) {
        return;
      }
      this.prevX = undefined;
      var touchEnd = evt.pageX || evt.changedTouches[0].pageX;
      var xDiff = this.touchStart - touchEnd;
      if (xDiff > 0) {
        this.next(evt);
      }
      if (xDiff < 0) {
        this.prev(evt);
      }
      this.touchStart = null;
    }
  },
  components: {
    Settings
  }
};
</script>

<style lang="sass">
.authorInfo p > span,
.authorInfo p > em
  font-size: 33px
  font-family: fontFamily
  font-style: italic
  background-color: #f3f3f3 !important

.toc span.black
  background-color: #f3f3f3 !important
  color: #2c3e50 !important

.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active
  transition: transform 350ms cubic-bezier(1, 0, 0, 1)
  position: absolute
  column-count: 2
  column-width: 220px
  column-gap: 40px
  height: 100vh
  max-height: calc(100vh - 50px) !important
  overflow-x: scroll
  overflow-y: -moz-hidden-unscrollable
  padding: 0 20px 60px
  text-align: initial
  column-fill: balance
  h1,
  h2,
  h3,
  h4,
  h5,
  h6
    font-family: 'Cabin'
    float: left
  a
    display: inline-block !important
    width: 100%
    float: left
  p, li
    display: inline-block
    overflow: hidden
    float: left
  .coverImage, .seperator img, .inner_page img
    max-width: 100%
    max-height: calc(100vh - 145px) !important
    margin-bottom: 10px
    margin-left: 50%
    transform: translate3d(-50%, 0, 0)
    -webkit-transform: translate3d(-50%, 0, 0)
  .Inset
    width: 100%
  .subA
    font-weight: bold
    line-height: 3rem
  ol>li:last-child
    margin-bottom: 16px
  td
    border-right: 1px solid grey
    border-bottom: 1px solid grey
    padding: 10px
    &:first-child
      border-left: 1px solid grey
  .headerRow
    border: 1px solid grey
  .subheader
    font-size: .9em
    height: auto
    display: block
    width: 100%
    font-style: italic

.slide-right-enter,
.slide-left-leave-to
  transform: translate3d(-100%, 0, 0)

.slide-right-enter-to,
.slide-left-leave,
.slide-right-leave,
.slide-left-enter-to
  transform: translate3d(0, 0, 0)

.slide-left-enter,
.slide-right-leave-to
  transform: translate3d(100%, 0, 0)

</style>



// WEBPACK FOOTER //
// Reader.vue?58434f10